import axios from '../utils/axios';

export default function updateTagName(adminId, body) {
    return axios.post(`/admin/${adminId}/update-tag-name`, body);
};